import { createFileRoute } from '@tanstack/react-router';

import { messagesSearchSchema } from '@/pages/messages/chat-search';
import { MessagesMobilePage } from '@/pages/messages/messages-mobile-page';
import { MessagesPage } from '@/pages/messages/messages-page';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * Chat — the one chat surface (W5-B): direct messages + every team's
 * channels, with threads.  Deep-link contract (`?dm=` · `?team=&topic=` ·
 * `&thread=` · `?team=` alone = filtered to that team · `?requests=1`) in
 * `pages/messages/chat-search.ts`.
 */
function MessagesRoute() {
  const isMobile = useMobile();
  return isMobile ? <MessagesMobilePage /> : <MessagesPage />;
}

export const Route = createFileRoute('/my/messages')({
  validateSearch: messagesSearchSchema,
  component: MessagesRoute,
});
